module.exports = __webpack_public_path__ + "static/media/icon-ballon-128.fa884b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sprites/128x128/icon-ballon-128.png
// module id = 826
// module chunks = 0